import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Button } from "reactstrap";
// select
import Select from "react-select";
// componentes
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { createLoginStatusVehicle } from "../../../utils/services/loginStatusVehicle";

export default function ModalEditStatusPart(props) {
  const {
    isOpen,
    toggle,
    eventId,
    vehicleId,
    loginId,
    previousStatus,
    getAll,
    bulkData,
    changeStatusBySelection,
    handleSelectAll,
  } = props;

  const [isLoading, setIsloading] = useState(false);
  // valor do campo
  const [selected, setSelected] = useState(
    previousStatus
      ? {
          label: previousStatus,
          value: previousStatus,
        }
      : {}
  );
  //   alerta
  const [success, setSuccess] = useState(false);

  async function changeLoginStatusVehicle() {
    setIsloading(true);
    const data = {
      eventId: eventId,
      vehicleId: vehicleId,
      loginId: loginId,
      previousStatus: previousStatus ? previousStatus : "",
      newStatus: selected.value,
      notes: "",
    };

    await createLoginStatusVehicle(data).then((res) => {
      setIsloading(false);
      setSuccess(true);
      getAll();
    });
  }

  async function bulkUpdateStatusVehicle() {
    setIsloading(true);
    const newArr = bulkData.map((item) => ({
      eventId: eventId,
      vehicleId: vehicleId,
      loginId: item.participantId,
      previousStatus: item.status ? item.status : "",
      newStatus: selected.value,
      notes: "",
    }));

    try {
      await Promise.all(
        newArr.map(async (data) => {
          await createLoginStatusVehicle(data);
        })
      );
      setIsloading(false);
      setSuccess(true);
      getAll();
    } catch (error) {
      console.log("erro", error);
      setIsloading(false);
      setSuccess(false);
    }
  }

  return (
    <>
      {success && (
        <SweetAlert
          success
          title={"Atualizado"}
          onConfirm={() => {
            if (handleSelectAll) handleSelectAll(false);
            setSuccess(false);
            toggle();
          }}
        >
          {"Status atualizado com sucesso!"}
        </SweetAlert>
      )}

      <Modal isOpen={isOpen} centered autoFocus>
        <ModalHeader toggle={toggle}>Status</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <label className="form-label">Alterar Status *</label>

              <Select
                placeholder={"Selecione"}
                onChange={(e) => {
                  setSelected(e);
                }}
                value={selected}
                options={[
                  {
                    options: [
                      { label: "Embarcado", value: "Embarcado" },
                      { label: "Desembarcado", value: "Desembarcado" },
                      { label: "Não Embarcou", value: "Não Embarcou" },
                    ],
                  },
                ]}
                classNamePrefix="select2-selection"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                    overflowY: "auto",
                  }),
                }}
              />
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>

            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              isDisabled={!selected.value || selected.value === previousStatus}
              marginLeft={10}
              action="U"
              onClick={() => {
                if (!changeStatusBySelection) {
                  changeLoginStatusVehicle();
                } else {
                  bulkUpdateStatusVehicle();
                }
              }}
            />
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}
